// components/FolderList.styled.ts
import FolderIcon from "@mui/icons-material/Folder";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const FolderContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem 0;
`;

export const FolderItem = styled.div`
    width: 20%;
    margin: 0.5rem;
    text-align: center;
    cursor: pointer;
    position: relative;

    &:hover {
        opacity: 0.8;
    }

    ${device.md} {
        width: 15%;
    }

    ${device.lg} {
        width: 10%;
    }

    ${device.xl} {
        width: 5%;
    }
`;

export const StyledFolderIcon = styled(FolderIcon)`
    && {
        font-size: 3rem;
        color: ${colourScheme.secondaryDark};
    }
`;

export const FolderName = styled.div`
    margin-top: 0.5rem;
    color: ${colourScheme.white};
    font-weight: bold;
`;

export const FolderActions = styled.div`
    position: absolute;
    top: 0rem;
    right: -1rem;
    display: flex;
    align-items: center;
`;

export const ActionButton = styled.button`
    background: none;
    border: none;
    color: ${colourScheme.white};
    cursor: pointer;
    font-size: 1rem;
    margin-right: 0.5rem;

    &:hover {
        color: ${colourScheme.primaryLight};
    }

    &:last-child {
        margin-right: 0;
    }

    svg {
        margin-right: 0.5rem;
    }
`;
